import styled from 'styled-components';

export const Select = styled.select`
  color: #fff;
  background-color: #393e44;
  border: solid 1px #a3b0c0;
  cursor: pointer;
  /* max-width: 100%; */
`;
